/**
 * Client side error where `message` is expected to be a phrase key and
 * `errorData` is a record of values to be passed to `FormattedMessage`
 */
export class ClientError extends Error {
  constructor(
    message: string,
    public errorData: Record<string, any> = {}
  ) {
    super(message)
  }
}
